import gql from 'graphql-tag';
import { reset, change } from 'redux-form';

import {
  SEARCH_LISTING_START,
  SEARCH_LISTING_SUCCESS,
  SEARCH_LISTING_ERROR,
} from '../constants';

import { getSearchResults } from './getSearchResults';
import { trackSearch } from '../core/analytics';

export const searchQuery = gql`
  query(
    $dates: String
    $currentPage: Int
    $lat: Float
    $lng: Float
    $roomType: [Int]
    $priceRange: [Int]
    $geography: String
    $geoType: String
    $searchByMap: Boolean
    $sw_lat: Float
    $sw_lng: Float
    $ne_lat: Float
    $ne_lng: Float
    $keyword: String
    $radiusMiles: Int
    $minimumRating: Int
  ) {
    SearchListing(
      dates: $dates
      currentPage: $currentPage
      lat: $lat
      lng: $lng
      categories: $roomType
      priceRange: $priceRange
      geography: $geography
      geoType: $geoType
      searchByMap: $searchByMap
      sw_lat: $sw_lat
      sw_lng: $sw_lng
      ne_lat: $ne_lat
      ne_lng: $ne_lng
      keyword: $keyword
      radiusMiles: $radiusMiles
      minimumRating: $minimumRating
    ) {
      count
      results {
        id
        title
        coverPhoto
        reviewsCount
        reviewsStarRating
        basePrice
        distance
        listPhotos {
          id
          name
          type
          status
        }
        isListOwner
        listingAddresses {
          id
          addressId
          lat
          lng
          distance
        }
      }
    }
  }
`;

export function searchListing({
  dates,
  geography,
  currentPage,
  geoType,
  lat,
  lng,
  categories,
  kw,
  minimumRating,
  priceRange,
  location,
  ne_lat,
  ne_lng,
  searchByMap,
  sw_lat,
  sw_lng,
}) {
  return async (dispatch, getState, { client }) => {
    dispatch({ type: SEARCH_LISTING_START });
    dispatch(reset('SearchForm'));

    const variables = {
      dates,
      currentPage,
      geography,
      roomType: categories,
      keyword: kw,
      geoType,
      lat,
      lng,
      priceRange,
      minimumRating,
      locationKeywords: location,
      ne_lat,
      ne_lng,
      searchByMap,
      sw_lat,
      sw_lng,
    };
    try {
      const { data } = await client.query({
        query: searchQuery,
        variables,
        fetchPolicy: 'network-only',
      });
      if (data.SearchListing) {
        variables.total = data.SearchListing.count;
        trackSearch(variables);

        dispatch({ type: SEARCH_LISTING_SUCCESS });
        await dispatch(change('SearchForm', 'dates', dates));
        await dispatch(change('SearchForm', 'geography', geography));
        await dispatch(change('SearchForm', 'currentPage', currentPage));
        await dispatch(change('SearchForm', 'roomType', categories));
        await dispatch(change('SearchForm', 'kw', kw));
        await dispatch(change('SearchForm', 'geoType', geoType));
        await dispatch(change('SearchForm', 'lat', lat));
        await dispatch(change('SearchForm', 'lng', lng));
        await dispatch(change('SearchForm', 'searchByMap', searchByMap));
        await dispatch(change('SearchForm', 'sw_lat', sw_lat));
        await dispatch(change('SearchForm', 'sw_lng', sw_lng));
        await dispatch(change('SearchForm', 'ne_lat', ne_lat));
        await dispatch(change('SearchForm', 'ne_lng', ne_lng));
        await dispatch(change('SearchForm', 'initialLoad', true));
        dispatch(getSearchResults(data.SearchListing));
      }
    } catch (error) {
      dispatch({
        type: SEARCH_LISTING_ERROR,
        payload: {
          error,
        },
      });
      return false;
    }

    return true;
  };
}



// WEBPACK FOOTER //
// ./src/actions/searchListing.js